import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const changeSubscription: DocumentNode = gql`
  mutation ChangeSubscription($subscriptionId: String!, $planCode: String!, $couponCodes: [String]) {
    changeSubscription(id: $subscriptionId, input: { planCode: $planCode, couponCodes: $couponCodes }) {
      ... on SubscriptionChange {
        id
        plan {
          code
          name
        }
        unitAmount
      }
      ... on SubscriptionChangeNotFound {
        error {
          message
        }
      }
      ... on SubscriptionChangeInvalid {
        type
        message
        transactionError {
          transactionId
          message
          merchantAdvice
          code
          category
        }
        error {
          type
          message
          params
          transactionError {
            transactionId
            message
            merchantAdvice
            code
            category
          }
        }
      }
    }
  }
`

export default changeSubscription
